'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onChangeSymbolDim = exports.symbolStateFromNewProps = exports.toSymbolSingularity = exports.isSymbol = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _ = require('../');
var _constants = require('../constants');
var _utils = require('./utils');
var _focus = require('./focus');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getSymbolDimension = (0, _utils.getPropertyDimension)('symbolDimension');
var isSymbol = exports.isSymbol = function isSymbol(type) {
  return type === _constants.H_SYMBOL || type === _constants.V_SYMBOL;
};
var toSymbolState = function toSymbolState(dimension) {
  return {
    symbolDimension: (0, _utils.toState)(dimension)
  };
};
var toSymbolSingularity = exports.toSymbolSingularity = function toSymbolSingularity(data, state) {
  var symbolDimension = getSymbolDimension(data, state);
  var res = {
    id: R.isNil(symbolDimension) ? undefined : R.prop('id', symbolDimension),
    serie: R.pipe(R.prop('values'), function (values) {
      return R.isNil(values) ? [] : values;
    }, R.take(5))(symbolDimension)
  };
  return res;
};
var symbolStateFromNewProps = exports.symbolStateFromNewProps = function symbolStateFromNewProps(props, state) {
  var data = props.data,
    type = props.type;
  if (!isSymbol(type)) {
    return toSymbolState(undefined);
  }
  if (R.isNil(data)) {
    return {};
  }
  var dimensions = (0, _utils.getDimensionsWithValues)(data);
  if (R.isEmpty(dimensions)) {
    return (0, _extends3.default)({}, toSymbolState(undefined), {
      baseline: [],
      highlight: []
    });
  }
  var symbolDimension = getSymbolDimension(data, state);
  if (R.isNil(symbolDimension)) {
    var _getGroupedDimensions = (0, _utils.getGroupedDimensions)(data),
      area = _getGroupedDimensions.area,
      other = _getGroupedDimensions.other,
      time = _getGroupedDimensions.time;
    if (!R.isNil(other) && !R.isEmpty(other)) {
      symbolDimension = R.head(other);
    } else if (!R.isNil(time) && !R.isEmpty(time)) {
      symbolDimension = R.head(time);
    } else {
      symbolDimension = R.head(area);
    }
  }
  var symbolState = toSymbolState(symbolDimension);
  return (0, _extends3.default)({}, symbolState, (0, _focus.focusStateFromNewProps)(props, toSymbolSingularity(data, symbolState), state));
};
var onChangeSymbolDim = exports.onChangeSymbolDim = function onChangeSymbolDim(_ref) {
  var data = _ref.data;
  return function (option) {
    var dimension = getSymbolDimension(data, {
      symbolDimension: option
    });
    if (R.isNil(dimension)) {
      return {};
    }
    return (0, _extends3.default)({}, toSymbolState(dimension), {
      highlight: [],
      baseline: []
    });
  };
};